import React from "react";
import "../lifehacks/ArticleFull.css";

const BeachWaterQuality = () => {
  return (
    <div className="article-full">
      <h2 className="article-subtitle">Проверка качества воды на пляжах Санта-Катарины: как использовать сайт IMA</h2>
      <div className="article-section">
        <p className="article-text">
          Собираетесь на пляжи Санта-Катарины? Убедитесь, что вода безопасна для купания! Институт охраны окружающей среды штата Санта-Катарина (IMA) создал удобный онлайн-сервис на сайте balneabilidade.ima.sc.gov.br, где вы можете проверить актуальное состояние воды на побережье. Погрузитесь в отдых с уверенностью, что ваше здоровье под защитой!
        </p>
        <p className="article-text">
          Источник: <a href="https://www.ima.sc.gov.br" target="_blank" rel="noopener noreferrer" className="article-link">ima.sc.gov.br</a>
        </p>
      </div>

      <div className="article-section">
        <h3 className="article-section-title">🧪 Что такое балнеабилитация?</h3>
        <p className="article-text">
          Балнеабилитация — это наука о безопасности воды для купания. IMA еженедельно (с ноября по март) и ежемесячно (с апреля по октябрь) проверяет качество воды на 238 точках вдоль 500 км побережья Санта-Катарины. Главный враг — бактерия Escherichia coli, которая сигнализирует о фекальном загрязнении. Если её слишком много, купаться не стоит — здоровье важнее!
        </p>
      </div>

      <div className="article-section">
        <h3 className="article-section-title">🌐 Как пользоваться сайтом IMA?</h3>
        <p className="article-text">
          Сайт balneabilidade.ima.sc.gov.br — ваш гид по безопасным пляжам. На главной странице вы найдёте интерактивную карту, где каждый пляж отмечен цветной иконкой:
        </p>
        <ul className="article-list">
          <li>🔵 Синий — вода чистая, купаться можно!</li>
          <li>🔴 Красный — вода загрязнена, лучше воздержаться.</li>
          <li>⚪ Серый — данные отсутствуют или неопределённы.</li>
        </ul>
        <p className="article-text">
          Чтобы узнать подробности:
        </p>
        <ul className="article-list">
          <li>Выберите муниципалитет и пляж из выпадающих списков.</li>
          <li>Нажмите кнопку Balneabilidade, чтобы увидеть текущий статус.</li>
        </ul>
        <p className="article-text">
          Хотите копнуть глубже? Перейдите во вкладку Histórico de Balneabilidade, чтобы изучить историю качества воды, или скачайте PDF-отчёты для детального анализа.
        </p>
        <p className="article-text">
          Проверить данные: <a href="https://balneabilidade.ima.sc.gov.br" target="_blank" rel="noopener noreferrer" className="article-link">balneabilidade.ima.sc.gov.br</a>
        </p>
      </div>

      <div className="article-section">
        <h3 className="article-section-title">📱 Мобильное приложение Praia Segura</h3>
        <p className="article-text">
          Нет ноутбука под рукой? Скачайте приложение Praia Segura, созданное совместно с пожарной службой Санта-Катарины. Оно дублирует данные сайта IMA, показывая статус пляжей в реальном времени. Удобно, быстро и всегда под рукой — идеально для спонтанных поездок к морю!
        </p>
      </div>

      <div className="article-section">
        <h3 className="article-section-title">⚠️ Рекомендации для купающихся</h3>
        <p className="article-text">
          Чтобы отдых был безопасным, следуйте советам IMA:
        </p>
        <ul className="article-list">
          <li>Избегайте купания 24–48 часов после сильных дождей — ливни могут принести загрязнения.</li>
          <li>Держитесь подальше от устьев рек и дренажных каналов, где вода чаще всего загрязнена.</li>
          <li>Перед поездкой проверяйте статус пляжа на сайте или в приложении Praia Segura.</li>
        </ul>
        <p className="article-text">
          С этими простыми шагами вы обеспечите себе и близким беззаботный отдых на пляжах Санта-Катарины!
        </p>
      </div>
    </div>
  );
};

export default BeachWaterQuality;